import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleByPermissionDirective } from './toggle-by-permission.directive';
import { DisableByPermissionDirective } from './disable-by-permission.directive';
import { GuardCtaByPermissionDirective } from './guard-cta-by-permission.directive';
import { PermissionDeniedDialogComponent } from './permission-denied-dialog.component';

@NgModule({
  declarations: [
    ToggleByPermissionDirective,
    DisableByPermissionDirective,
    GuardCtaByPermissionDirective,
    PermissionDeniedDialogComponent
  ],
  imports: [CommonModule, MatDialogModule, TranslateModule],
  exports: [
    ToggleByPermissionDirective,
    DisableByPermissionDirective,
    GuardCtaByPermissionDirective
  ]
})
export class PermissionsModule {}


